import React from 'react';
import LandingSection from 'containers/aboutPage/aboutLanding';
import MainSection from 'containers/aboutPage/aboutMain';
import NewsSection from 'containers/aboutPage/aboutNews';
import Footer from 'containers/footer';

import {useDataValue} from 'globals/contexts/dataContext';

import './aboutPage.css';

const AboutPage = () => {
  const [{content, currentLanguage}] = useDataValue();
  const pageContent = content['content'][currentLanguage]['pages']['about'];
  return <div id="about" className="page">
    <LandingSection content={pageContent['landing']} />
    <MainSection content={pageContent['main']} />
    <NewsSection content={pageContent['news']} />
    <Footer />
  </div>;
};

export default AboutPage;